import { FunctionComponent } from "react";
import { IconProps } from "./IconProps";

const ExternalLinkIcon: FunctionComponent<IconProps> = ({
  size = 24,
  color,
  testID,
}) => (
  <svg
    width={size}
    height={size}
    color={color}
    data-testid={testID}
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M5 3C3.90694 3 3 3.90694 3 5V19C3 20.0931 3.90694 21 5 21H19C20.0931 21 21 20.0931 21 19V12H19V19H5V5H12V3H5ZM14 3V5H17.5859L8.29297 14.293L9.70703 15.707L19 6.41406V10H21V3H14Z"
    />
  </svg>
);

export { ExternalLinkIcon };
